import { Heading } from "@tennr/frontend/components/Heading";
import "./Press.css";
import type { Ref, FC } from "react";
import { PressCard } from "./PressCard";

export interface PressSectionProps {
  title?: string;
  subtitle?: string;
  body?: string;
  logos?: {
    src: string;
    url?: string;
  }[];
  progress?: any; // Should be a MotionValue<number> (0-1), defaults to useMotionValue(0)
  stagger?: number; // seconds, for element delay
  animated?: boolean; // Whether to animate the cards
  cardVariant?: "dark" | "light";
  className?: string;
  ref?: Ref<HTMLDivElement>;
}

export const PressSection: FC<PressSectionProps> = ({
  title = "PRESS",
  subtitle = "Better operations make headlines",
  body = "What leading publications have to say about Tennr:",
    logos = [
    {
        src: "/img/publication-fortune.png",
        alt: "Fortune",
        url: "https://fortune.com/2025/06/18/tennr-health-tech-ai-patient-referral-ivp-a16z-lightspeed-iconiq-series-c/",
    },
    {
      src: "/img/publication-forbes.png",
      alt: "Forbes",
      url: "https://www.forbes.com/sites/davidprosser/2024/03/26/how-tennr-plans-to-ensure-patients-finally-get-to-see-their-doctors/?sh=49dcdecd5c16",
    },
    {
      src: "/img/publication-axios.png",
      alt: "Axios",
      url: "https://www.axios.com/2024/03/26/andreessen-tennr-fix-faxes-health-care",
    },
    {
      src: "/img/publication-bloomberg.png",
      alt: "Bloomberg",
      url: "https://www.bloomberg.com/news/articles/2024-03-26/this-ai-startup-is-trying-to-make-fax-machines-work-better",
    },
  ],
  // progress,
  // stagger = 0.1,
  animated = true,
  cardVariant,
  className = "",
  ref,
}) => {
  // always create a local motion value, but use the provided one if available

  // logo animation (staggered per logo)

  const logoAnims = logos.map(({ src, alt, url }) => {
    return {
      opacity: 1,
      scale: 1,
      delay: 0,
      src,
      alt,
      url,
      animated,
    };
  });

  return (
    <section className={`press section-y ${className}`} ref={ref}>
      <div className="press-cards-container">
        <div className="press-copy-container">
          <Heading
            heading={subtitle}
            title={title}
            body={body}
            position="center"
            variant="section"
            wrapHeading="balance"
            color={{
              type: "dynamic",
              lightTextColor: "#FFFFFF", // Use white instead of beige
              darkTextColor: "#000000", // Use black instead of green
              algorithm: "luminance",
            }}
          />
        </div>
        <div className="press-cards">
          {logoAnims.map((animation, i) => (
            <PressCard key={i} animation={animation} variant={cardVariant} />
          ))}
        </div>
      </div>
    </section>
  );
};
